import socket from "../socket";

window.sock = socket;
// Now that you are connected, you can join channels with a topic:
let channel = socket.channel("tracking:lobby", {});
let trackQueue = [];

export default {
  init: () =>
    new Promise((resolve, reject) => {
      channel
        .join()
        .receive("ok", () => {
          trackQueue.forEach((payload) => channel.push("track", payload));
          trackQueue = [];
          resolve(channel);
        })
        .receive("error", () => {
          reject("Socket connection not available");
          // TODO: retry
        });
    }),

  track(eventName, payload) {
    const insertedAt = new Date().toJSON();
    if (socket.isConnected()) {
      channel.push("track", {
        ...payload,
        event_name: eventName,
        inserted_at: insertedAt,
      });
    } else {
      trackQueue.push({
        ...payload,
        event_name: eventName,
        inserted_at: insertedAt,
      });
    }
  },
};
